import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function TerminePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-786">
      <Navbar data-id="element-787" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-788">
        <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-789">
          Termine
        </h1>
        <p className="text-lg text-slate-600 mb-12 max-w-2xl" data-id="element-790">
          Hier finden Sie in Kürze alle aktuellen Termine für unsere Kurse und
          das Curriculum.
        </p>
        <div className="bg-slate-50 border border-slate-200 rounded-2xl p-12 text-center" data-id="element-791">
          <p className="text-slate-500 font-medium" data-id="element-792">
            Terminübersicht wird geladen...
          </p>
        </div>
      </main>
      <Footer data-id="element-793" />
    </div>;
}